angular.module('impactx.rfx').controller('RFXSupportProcessesListCtrl', [
    '$scope',
    'selectedListItems',
    '$mdDialog',
    'ListHelperService',
    RFXSupportProcessesListCtrl
]);

function RFXSupportProcessesListCtrl($scope, selectedListItems, $mdDialog, ListHelperService) {
    var self = this;

    var buttonDefinition = [
        {
            label: "changeDate",
            action: changeDate,
            type: 'action',
            condition: selectedListItems.isSingleSelection,
            process: 'RFXSupportActivationDate'
        }
    ];

    self.meta = {
        rowTemplate: 'modules/rfx/templates/supportprocesseslist.row.tmpl.html',
        isSelectAble: true,
        ctrl: self,
        endpoint: '/rfx/support/openprocesses/list',
        id: "SupportOpenProcessesList",
        excelExport: true,
        buttonDefinition: buttonDefinition,
        valuesInteger: [
            {name: 'STATUS_PUBLISHED', value: 18},
            {name: 'STATUS_REPLIED', value: 50},
            {name: 'STATUS_ADDED_TO_BASKET', value: 66},
            {name: 'STATUS_SENT', value: 20}
        ]
    };
    self.getMeta = function () {
        return self.meta;
    };

    function changeDate(event) {
        $mdDialog.show({
            controller: 'RFXChangeSupportDateCtrl',
            controllerAs: 'rfxChangeSupportDateCtrl',
            templateUrl: 'modules/rfx/templates/rfx-change-supportdate.dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            escapeToClose: false,
            bindToController: true,
            locals: {
                rfqsId: selectedListItems.getFirstSelectedId()
            }
        }).then(function () {
            ListHelperService.refreshListData($scope, 'rfxSupportProcessesListCtrl', {unselectRows: []});
        })
    }
}